
import axios from '../api/login';
import {useNavigate} from 'react-router-dom';
import {useState} from 'react'
import { Eye, EyeOff } from "lucide-react";

import Spinner from 'react-bootstrap/Spinner';
function LoginUI({setAccessToken,setIsAuthenticated,setRefreshFailed,setGlobalLoginType}){
  const [userName,setUserName]=useState('');
  const [password,setPassword]=useState('');
  const navigate=useNavigate();
  const [isLoading,setIsloading]=useState(false);
  const [otpError,setOtpError]=useState('');
  const [loginType,setLoginType]=useState('admin');
  const [showSendOTP,setShowSendOTP]=useState(true);
  const [showPassword, setShowPassword] = useState(false);


  async function onUserNameChange(e)
  {
    setUserName(e.target.value);
    if(password.length<=0)
    {
      setShowSendOTP(true);
    }
    setOtpError('');
  }
  async function onPasswordChange(e)
  {
    setPassword(e.target.value);
    if(e.target.value.length>0)
    {
      setShowSendOTP(false);
    }
    else{
      setShowSendOTP(true);
    }
    setOtpError('');
  }

  const handleLoginTypeChange = (event) => {
    setLoginType(event.target.value);
  };
  
  async function handleLogin(e)
    {
      e.preventDefault();
      setIsloading(true);
      try{
            const config = { withCredentials: true };
            const data=await axios.post('/login',{
            userName:userName,
            password:password, 
            loginType:loginType           
            },config);
            //alert(JSON.stringify(data['data']['accesstoken']));
            setAccessToken(data['data']['accesstoken']);
            setGlobalLoginType(data['data']['loginType']);
            setIsAuthenticated(true);
            setRefreshFailed(false);
            setUserName('');
            setPassword('');
            navigate('/');              
                       
      }
      catch(err)
      {
        //alert(err);
        setAccessToken('');
        setIsAuthenticated(false);
        setGlobalLoginType('');
        setRefreshFailed(true);
        alert('Login failed!');
      }
      finally
      {
        setIsloading(false);     
      }
    }

    async function handleStudentLogin(e)
    {
      e.preventDefault();
      setIsloading(true);
      try{
            const config = { withCredentials: true };
            const data=await axios.post('/login',{
            userName:userName,
            password:password, 
            loginType:'student'           
            },config);
            //alert(JSON.stringify(data['data']['accesstoken']));
            setAccessToken(data['data']['accesstoken']);
            setGlobalLoginType(data['data']['loginType']);
            setIsAuthenticated(true);
            setRefreshFailed(false);
            setUserName('');
            setPassword('');
            navigate('/');              
                       
      }
      catch(err)
      {
        //alert(err);
        setAccessToken('');
        setIsAuthenticated(false);
        setGlobalLoginType('');
        setRefreshFailed(true);
        alert('Login failed!');
      }
      finally
      {
        setIsloading(false);     
      }
    }
  

    async function handleCancel(e)  {
      e.preventDefault();
      setLoginType('student');
    }
  async function handleNewStudent(e)  {
    e.preventDefault();
    setLoginType('newstudent');
  }

 
  const validateEmail = (value) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(value)) {
      setOtpError('Please enter a valid email address.');
      return false;
    } else {
      setOtpError('');
      return true;
    }
  };
async function hangleSendOTP(e)
  {
    e.preventDefault();
   

    if(validateEmail(userName))
     {
      setIsloading(true);
      setOtpError('');
      
      try{
      
            const config = { withCredentials: true };
            const data=await axios.post('/login/sendOTP',{
            userName:userName,
            password:password
            },config);
            if(data.data.message)
            {
              setOtpError(`${data.data.message}`);  
            }
            else{
              //alert(JSON.stringify(data.data.message));
              setOtpError(`Oops something went wrong!`);  
            }
            
                      
      }
      catch(err)
      {
        alert(JSON.stringify(err));
        setOtpError(err&&err.response&&err.response.data&&err.response.data.error?err.response.data.error:'OOPS! something went wrong!');
        setAccessToken('');
        setIsAuthenticated(false);
        setRefreshFailed(true);
        //alert('Login failed!');
      }
      finally
      {
        setIsloading(false);     
      }
    }
  }  


  async function handleNewLogin(e)  {
    e.preventDefault();
    setIsloading(true);
    try{
          const config = { withCredentials: true };
          const data=await axios.post('/login/handleNewLogin',{
          userName:userName,
          password:password,         
          },config);
          //alert(JSON.stringify(data['data']['accesstoken']));
          setAccessToken(data['data']['accesstoken']);
          setGlobalLoginType(data['data']['loginType']);
          setIsAuthenticated(true);
          setRefreshFailed(false);
          setUserName('');
          setPassword('');
          navigate('/newStudent');              
          //alert('navigate to new registration form');
                     
    }
    catch(err)
    {
      //alert(err);
      setAccessToken('');
      setIsAuthenticated(false);
      setGlobalLoginType('');
      setRefreshFailed(true);
      alert('Login failed!');
    }
    finally
    {
      setIsloading(false);     
    }
  }


    return (  
      <main>
        <form className="loginForm">
          
          
         {loginType === 'admin' && (
  <div className="loginDiv marginTopm">
    <label>USER NAME:</label>
    <input
      className="borderLess transparent"
      type="text"
      onChange={(e) => setUserName(e.target.value)}
      value={userName}
    />

    <label className="marginTop">PASSWORD</label>
    <div className="relative w-full">
      <input
        className="borderLess transparent pr-10"
        type={showPassword ? "text" : "password"}
        onChange={(e) => setPassword(e.target.value)}
        value={password}
      />

      <span
        className="absolute right-2 top-1/2 -translate-y-1/2 cursor-pointer text-gray-600"
        onClick={() => setShowPassword(!showPassword)}
      >
        {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
      </span>
    </div>

    <div className="marginTop w-full flex justify-between">
      <button className="bg-green-500 text-gray-800 hover:bg-green-800 hover:text-gray-200 px-2 py-1 rounded-md text-sm" name='btnLogin' onClick={handleStudentLogin}>
        STUDENT LOGIN
      </button>
      <button className="bg-blue-500 text-gray-800 hover:bg-blue-800 hover:text-gray-200 px-2 py-1 rounded-md text-sm" name='btnLogin' onClick={handleLogin}>
        ADMIN LOGIN
      </button>
    </div>
    <div className="marginTop fullWidth loginButtonyNav">            
            <p className='w-full p-1 text-sm text-center'>
              Dear students,<br />
              Please use your <strong>samarth registration number</strong> as user name and  your <strong>full name in capital letters, without any spaces</strong>, as your password.<br />
              For example, if your samarth registration number is <strong>230224445</strong> and your name is <strong>Monalisa Das</strong>, then your <br/>user name is 230224445<br/>and password is
              <strong>MONALISADAS</strong>
            </p>
            </div>
  </div>
)}


          
        </form>

        {isLoading && 
        <div className='spinneroverlay'>
          <div className='spinnerbody'>
            <Spinner animation="border" variant="info" />
            <p>Please wait. It might take a few seconds.</p>
          </div>           
        </div>}
      </main> 

       );
}
export default LoginUI;
